function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccLoans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#E4F2E6",
    style: {
      fill: "#E4F2E6",
      fill: "color(display-p3 0.8941 0.9490 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5272 58.0758H28.4502C27.7361 58.0758 27.0513 57.7921 26.5464 57.2872C26.0415 56.7823 25.7578 56.0975 25.7578 55.3834V33.8447C25.7578 33.1306 26.0415 32.4458 26.5464 31.9409C27.0513 31.436 27.7361 31.1523 28.4502 31.1523H60.7582C61.4723 31.1523 62.1571 31.436 62.662 31.9409C63.1669 32.4458 63.4506 33.1306 63.4506 33.8447V41.9217",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5156 44.622C36.5156 43.908 36.7993 43.2232 37.3042 42.7183C37.8091 42.2133 38.4939 41.9297 39.208 41.9297H71.5161C72.2301 41.9297 72.9149 42.2133 73.4198 42.7183C73.9247 43.2232 74.2084 43.908 74.2084 44.622V66.1608C74.2084 66.8748 73.9247 67.5596 73.4198 68.0645C72.9149 68.5694 72.2301 68.8531 71.5161 68.8531H39.208C38.4939 68.8531 37.8091 68.5694 37.3042 68.0645C36.7993 67.5596 36.5156 66.8748 36.5156 66.1608V44.622Z",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 55.3964C49.9922 56.8245 50.5595 58.1941 51.5693 59.2039C52.5791 60.2138 53.9488 60.7811 55.3769 60.7811C56.805 60.7811 58.1746 60.2138 59.1844 59.2039C60.1942 58.1941 60.7616 56.8245 60.7616 55.3964C60.7616 53.9683 60.1942 52.5987 59.1844 51.5889C58.1746 50.579 56.805 50.0117 55.3769 50.0117C53.9488 50.0117 52.5791 50.579 51.5693 51.5889C50.5595 52.5987 49.9922 53.9683 49.9922 55.3964Z",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccLoans);
export default __webpack_public_path__ + "static/media/AccLoans.2cafe4e26d4d8ef37ef90cc76f1f029c.svg";
export { ForwardRef as ReactComponent };